import { render, staticRenderFns } from "./ErrorState.vue?vue&type=template&id=64287a78&scoped=true"
import script from "./ErrorState.vue?vue&type=script&lang=js"
export * from "./ErrorState.vue?vue&type=script&lang=js"
import style0 from "./ErrorState.vue?vue&type=style&index=0&id=64287a78&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64287a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64287a78')) {
      api.createRecord('64287a78', component.options)
    } else {
      api.reload('64287a78', component.options)
    }
    module.hot.accept("./ErrorState.vue?vue&type=template&id=64287a78&scoped=true", function () {
      api.rerender('64287a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ui/errorState/ErrorState.vue"
export default component.exports